<div class="flex flex-col flex-auto w-full lg:max-w-7xl">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
        <h2>{{ 'label_your_documents_jobs' | translatePlural }}</h2>
        <p>
            {{ 'info_your_documents_jobs' | translate }}
        </p>
    </div>

    <span class="separator-line w-100 mt-1"></span>
    <div class="mat-table-wrapper overflow-x-auto">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-full min-w-128">
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>#</th>
                <td mat-cell *matCellDef="let element">{{ element.id }}</td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                    {{ 'label_name' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                    <a class="c-link" [matTooltip]="'label_open_job' | translate" [routerLink]="['/vinnslur', element.id]">
                        {{ getDocumentJobDisplayName(element) }}
                    </a>
                </td>
            </ng-container>

            <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef>
                    {{ 'label_created_at' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.createdAt | date: 'dd.MM.yyyy HH:mm:ss' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>
                    {{ 'label_status' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" [matTooltip]="getStatusTooltip(element)" matTooltipClass="whitespace-pre">
                    @if (element.status == jobStatus.FINISHED) {
                        <mat-icon class="relative top-1 icon-size-5 text-green-600" fontIcon="check_circle"></mat-icon>
                    }
                    @if (element.status == jobStatus.FINISHED_WITH_FAILURES) {
                        <mat-icon class="relative top-1 icon-size-5 text-red-800" fontIcon="cancel"></mat-icon>
                    }
                    @if (element.status == jobStatus.PROCESSING) {
                        <mat-icon class="relative animate-spin top-1 icon-size-5 text-blue-600" fontIcon="autorenew"></mat-icon>
                    }
                    @if (element.status == jobStatus.CANCELLED) {
                        <mat-icon class="relative top-1 icon-size-5 text-gray-500" fontIcon="block"></mat-icon>
                    }
                    {{ getStatusMessage(element) }}
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-icon class="icon-size-5 relative top-1" fontIcon="more_horiz"></mat-icon>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="flex">
                        @if (element.status == jobStatus.FINISHED_WITH_FAILURES) {
                            <button
                                mat-icon-button
                                type="button"
                                matTooltipShowDelay="500"
                                [matTooltip]="'label_rerun_failed_document_job_messages' | translate"
                                (click)="onRerunFailedJobs(element)"
                            >
                                <mat-icon class="icon-size-5" fontIcon="refresh"></mat-icon>
                            </button>
                        }
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <tr class="mat-row relative" *matNoDataRow>
                <div class="flex items-center justify-between">
                    <span class="ml-2 font-medium text-secondary mt-[5px]">
                        {{ 'info_documents_jobs_found_count' | translate: { count: 0 } }}
                    </span>
                </div>
            </tr>
        </table>
        <mat-paginator #tablePaginator class="justify-end" showFirstLastButtons [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]">
        </mat-paginator>
    </div>
</div>
